import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DoCheck,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn} from '@angular/forms';
import {ChannelConfig, CMSConditions, Step} from '../../../../shared/models';
import {
    DataTypes,
    DynamicLayout,
    formBuilderConstants,
    Layout,
    LayoutOptions,
    MyFormBuilder,
    SplitPath,
} from './formbuilder';
import {menuTypes} from './types/menu/menu';
import {actionTypes} from './types/actions/action';
import {FlowManagerService} from '../../services/flow-manager.service';
import {Observable, Subscription} from 'rxjs';
import {newStepValue} from '../../services/flowBuilder/utils/constants';
import {FlowBuilderService} from '../../services/flowBuilder/flow-builder.service';
import {ActiveFormService} from '../../services/active-form.service';
import {getValidators, validHeader} from '../../../../shared/utils';
import {swalMini} from '../../../../shared/utils/utils';
import {FlowWebSocketsService} from '../../services/flowBuilder/flow-web-sockets.service';
import {startType} from './types/start';
import {integration} from './types/integration/integration';
import assign from 'lodash/assign';
import reduce from 'lodash/reduce';
import isObject from 'lodash/isObject';
import isEqual from 'lodash/isEqual';
import map from 'lodash/map';
import get from 'lodash/get';
import hasIn from 'lodash/hasIn';
import values from 'lodash/values';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import {MatDialog} from '@angular/material/dialog';
import {moveItemInArray} from '@angular/cdk/drag-drop';
import {MatAccordion} from '@angular/material/expansion';
import filter from 'lodash/filter';
import uniq from 'lodash/uniq';
import {MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {shareReplay, tap} from 'rxjs/operators';
import {Environment, SharedService} from '../../../../core/services/store/shared-store/shared-storage.service';
import {RolesService} from '../../../../core/services/roles/roles.service';
import {UserStoreService} from '../../../../core/services/store/UserStore/user-store.service';
import {Store} from '@ngrx/store';
import {selectNodeTypesMap} from '../../../../core';
import {
    DISPLAY_TYPE_INDEX_LIMIT,
    displayTypeChannels,
    DisplayTypeModalData
} from '../node-delegator/nodes/templates/display-type-dialog/displayTypeUtils';
import {DisplayTypeService} from '../../services/display-type.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {CollectionItem} from '../../../analytics-settings/services/collection.model';
import {CollectionService} from '../../../analytics-settings/services/collection.service';
import {
    AnalyticsSettingsComponent
} from '../node-delegator/nodes/templates/analytics-settings/analytics-settings.component';
import isEmpty from 'lodash/isEmpty';
import {
    WhatsAppSettingsComponent
} from "../node-delegator/nodes/templates/whats-app-settings/whats-app-settings.component";
import {NodeSupportedChannels} from "../../../../shared/utils/nodeTypes";

const ATTRIBUTES = formBuilderConstants.ATTRIBUTES;
const LIST_KEY = formBuilderConstants.LIST_KEY;
const PLACEHOLDER = formBuilderConstants.PLACEHOLDER;
const PATH_SEPARATOR = formBuilderConstants.PATH_SEPARATOR;
const DATA_ATTRIBUTE = formBuilderConstants.DATA_ATTRIBUTE;
const SPLIT_PATH = formBuilderConstants.SPLIT_PATH;

const MENUS = menuTypes;
const ACTIONS = actionTypes;
const START = startType;
const INTEGRATION = integration;

const formTypes = assign({}, MENUS, ACTIONS, START, INTEGRATION);
const editMenuTextOnlyFieldKeys = [
  'menuHeader',
  'text',
  'optionSeparator',
  'cardText',
  'noCardsText',
  'deleteCardConfirmationText',
  'linkText',
  'noAgentMessage',
  'successfullyConnectedMessage',
  'businessHours',
];

type PaneType = 'left' | 'right';

@Component({
  selector: 'json-to-from',
  templateUrl: './json-to-from.component.html',
  styleUrls: ['./json-to-from.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('slide', [
            state('left', style({ transform: 'translateX(0)' })),
            state('right', style({ transform: 'translateX(-50%)' })),
            transition('* => *', animate(300))
        ])
    ]
})
export class JsonToFromComponent implements OnInit, DoCheck, OnChanges, OnDestroy {
  ADD_ATTRIBUTE = 'add';
  DELETE_ATTRIBUTE = 'delete';
  READONLY_ATTRIBUTE = 'readonly';
  RESULT_FIELD = 'result';
  RESULT_YES = 'yes';
  RESULT_NO = 'no';
  RESULT_ERROR = 'error';

  RESULT_OTHER = 'other';
  RESULT_TIMEOUT = 'timeout';
  RESULT_MAX_CONNECTIONS = 'max-connections';

  DATA_TYPE: DataTypes;
  isTrackNodeOverlayOpen = false;

  @Input() typeName: string;
  @Input() stepJson: any;
  @Input() stepTitle: string;
  @Input() isFlowLocked: boolean;
  @Input() isRecycleBinItem: boolean;
  @Input('supportedChannel') supported_channel: NodeSupportedChannels;

  @Output() saveNode = new EventEmitter<Object>();
  @Output() deleteNode = new EventEmitter<string>();
  @Output() deleteChildNode = new EventEmitter<string>();
  @Output() resetSelectedNode = new EventEmitter();

  @ViewChild('deleteParentNodeDialog', { static : true }) deleteParentNodeDialog: TemplateRef<any>;
  @ViewChild('analyticsSlider') analyticsSettingsOverlay: AnalyticsSettingsComponent;
  @ViewChild('whatsAppSettings') whatsAppSettingsOverlay: WhatsAppSettingsComponent;
  errorText: Boolean = false;

  @Input() activePane: PaneType = 'left';

  @ViewChild('LogicAccordion') accordion: MatAccordion;
  @ViewChild('searchMoneyType', {
      read: MatAutocompleteTrigger
  })
  autoComplete: MatAutocompleteTrigger;
  // todo: if flow has saved values we should reinit variables
    selectedActionType: 'authenticate' | 'logout';
  dropdownAuthType: string = formBuilderConstants.DEFAULT_SELECT_OPTION_VALUE;
  private channelSubscription: Subscription;
  private getAllChannelConfig: Subscription;
  private channelConfig: ChannelConfig[];
  public stepNumber: string;
  public showAnalyticsForm: Boolean = false;
  public selectedCollection= [];
  public collectionItems: CollectionItem[];
  public analyticsSettings: any;
  public waSettings: any;
  public canEditState: boolean;

  constructor(
    private fb: FormBuilder,
    private flowManagerService: FlowManagerService,
    public sharedService: SharedService,
    private rolesService: RolesService,
    private flowBuilder: FlowBuilderService,
    private flowWebSocket: FlowWebSocketsService,
    public userStore: UserStoreService,
    private activeFormService: ActiveFormService,
    private displayService: DisplayTypeService,
    private collectionService: CollectionService,
    public dialog: MatDialog,
    private store: Store,
    private cdf: ChangeDetectorRef
  ) {}

  nodeIcons;
  objectKeys = Object.keys;
  localFormTypes = formTypes;

  json: any = {};
  paths = [];
  groups = {};
  layout: { [index: string]: Layout | LayoutOptions };
  myDynamicForm: any = {};
  dataToAdd = {};
  show = true;
  dynamicData: DynamicLayout;
  optionData$: Observable<any>;
  idpListData$: Observable<any>;
  nodeType: any;
  currentSteps: string[];
  showMessage = false;
  childCount = 0;

  formValuePath: Array<string> = [];
  apiDetails: any;

  saveClicked: Boolean;
  canShowErrors: Boolean = true;

  subscribedOptionData$: Subscription;
  collapsed: Boolean = false;
  displayMessage: Boolean = false;

  mediaValueType: String = 'API';
  mediaAssetCache: String = '';
  mediaAPICache: String = '';

  isCurrentEnvProd: boolean = this.sharedService.getEnvironment() === 'prod';
  flowSubscription: Subscription;
  flows: object;
  showNextSelector: Boolean;
  isAuthProviderPresent: Boolean = true;
  chat2payAPIdata: any = null;
  filteredOptions = null;
  selectedMoneyType = null;
  activeSearchMoneyTypes = false;
  searchControl = new FormControl();
  loadingInProgress: Boolean = false;
  selected: String = '';

  currencyType: String = '';
  variableValue: String = '';
  predefineValue: String = '';
  initializeActionType: Boolean = false;
  warningMessage: Boolean = false;
  warningCondition = false;
  toolTipText = '';

  mediaInboundVarName = '';
  varNameAssets = '';
  varNameAPI = '';

  flowStepSelectionFormField: any = null;
  globalEnvironment: Environment;

  selectedChannel: number;
  currentIndex: number;
  allowedIndex: number | boolean;
  currentLogicOption: number = Number.MAX_SAFE_INTEGER;
  message = '';
  channelDisplayType = '';
  supportedChannels = displayTypeChannels;
  displayIndex = DISPLAY_TYPE_INDEX_LIMIT;
  allChannelConfig: ChannelConfig[];
  chat2payAllAPIData: any = null;
  channelDisplayTypeConfig = DISPLAY_TYPE_INDEX_LIMIT;
  integrationProductionListData$: any;
  integrationSandboxListData$: any;
  departmentListData$: any;

  selectNodeTypesMapSubscription: Subscription;
  chat2PayHasError: boolean = false;
  displayTypeModalData: DisplayTypeModalData;

  analyticsFormGroup: FormGroup = new FormGroup({});
  analyticsForm = this.fb.group({ });
  isLeftVisible: Boolean = false;
    ngOnInit() {
        this.analyticsFormGroup = this.fb.group({
            menuName: new FormControl({
                value: '',
                disabled: false
            }),
        });
      this.getCurrentCollections();
      this.flowSubscription = this.flowManagerService.getFlows_with_ids(true).pipe(shareReplay(1)).subscribe(flows => {
          this.showNextSelector = true;
          this.flows = flows;
      });
      this.selectNodeTypesMapSubscription = this.store.select(selectNodeTypesMap).subscribe(node => this.nodeIcons = node)
      this.currentSteps.push(newStepValue);
      window.addEventListener('scroll', this.scrollEvent, true);
      this.setStepNumber();
    this.forceChangeDetection();
    }

    setStepNumber() {
      if (this.stepTitle === 'start') {
        this.stepNumber = this.stepTitle;
        return;
      }
      this.stepNumber = this.stepTitle.match(/\d/g).join('');
      if (this.stepNumber.length > 7) {
        this.stepNumber = this.stepNumber.substring(0, 7) + '...';
      }
    }

    ngDoCheck(): void {
      if (
        JSON.stringify(this.globalEnvironment) !==
        JSON.stringify(this.sharedService.getGlobalEnvironment())
      ) {
        this.fetchIdpList(true);
        this.getIntDepDropdownList(true, 'integrations');
        this.getIntDepDropdownList(true, 'departments');
        this.globalEnvironment = Object.assign({}, this.sharedService.getGlobalEnvironment());
        this.canEditState = this.canEditFlows();
      }
        this.forceChangeDetection();
    }

  fetchIdpList(reload: boolean) {
      if (this.typeName === 'authenticate') {
        this.flowManagerService.getIdpList(reload).pipe(
            tap((resp: any) => {
                  if (resp.status === 200) {
                    const responseBody = resp.body;
                    const currentIdpList = [];
                    const idpObject = {};
                    const idpValues = responseBody;
                    for (const idpItem in idpValues) {
                      if (idpItem !== 'default') {
                        const idpHolderObject = {
                          name: idpValues[idpItem].name,
                          id: idpValues[idpItem].id,
                        };
                        if (idpValues[idpItem].status === 1) {
                        currentIdpList.push(idpHolderObject);
                        }
                      }
                      Object.assign(idpObject, currentIdpList);
                    }

                    const finalIdpArray = currentIdpList.reduce((value, object) => (
                        {...value, [object.id]: object.name}
                    ), {});

                    return this.idpListData$ = finalIdpArray;
                  } else {
                    return this.idpListData$ = null;
                  }
                }
            )
        ).subscribe(
            () => {
              this.layout['authProvider'][ATTRIBUTES]['options'] = this.idpListData$;
              this.setFormData();
              return this.idpListData$;
            },
            () => {
              this.loadingInProgress = false;
              this.chat2payAPIdata = null;
            }
        );
      }
    }

  getIntDepDropdownList(reload: boolean, endpoint: string) {
      if (this.typeName === 'chatdesk') {
          this.flowManagerService.getIntDepDropdownList(reload, endpoint).pipe(
              tap((resp: any) => {
                      if (resp.status === 200) {
                          const currentList = [];
                          const sandboxList = [];
                          const productionList = [];
                          const holderValues = resp.body;
                          for (const holderItem in holderValues) {
                              if (endpoint === 'integrations') {
                                  const currentHolderObject = {
                                      id: holderValues[holderItem].apiToken,
                                      channelTypeId: holderValues[holderItem].channelTypeId,
                                      apiToken: holderValues[holderItem].apiToken,
                                      production: holderValues[holderItem].production,
                                      sandbox: holderValues[holderItem].sandbox,
                                  };
                                  if (currentHolderObject.production) {
                                      productionList.push(currentHolderObject);
                                  } if (currentHolderObject.sandbox) {
                                      sandboxList.push(currentHolderObject);
                                  }
                              } else {
                                  const currentHolderObject = {
                                      id: holderValues[holderItem].id,
                                      name: holderValues[holderItem].name,
                                      description: holderValues[holderItem].description,
                                  };
                                  currentList.push(currentHolderObject);
                              }
                          }

                          if (endpoint === 'integrations') {
                              const productionListArray = productionList.reduce((value, object) => ({
                                  ...value,
                                  [object.id]: object.apiToken
                              }), {});
                              const sandboxListArray = sandboxList.reduce((value, object) => ({
                                  ...value,
                                  [object.id]: object.apiToken
                              }), {});

                              this.integrationProductionListData$ = productionListArray;
                              this.integrationSandboxListData$ = sandboxListArray;
                              return this.integrationProductionListData$ && this.integrationSandboxListData$;
                          } else {
                              const departmentArray = currentList.reduce((value, object) => ({
                                  ...value,
                                  [object.id]: object.name
                              }), {});
                              return this.departmentListData$ = departmentArray;
                          }
                      } else {
                          if (endpoint === 'integrations') {
                              this.integrationProductionListData$ = null;
                              this.integrationSandboxListData$ = null;
                          } else {
                              this.departmentListData$ = null;
                          }
                      }
                  }
              )
          ).subscribe(
              () => {
                  if (endpoint === 'integrations') {
                      this.layout['sandboxIntegration'][ATTRIBUTES]['options'] = this.integrationSandboxListData$;
                      this.layout['productionIntegration'][ATTRIBUTES]['options'] = this.integrationProductionListData$;
                  } else {
                      this.layout['department'][ATTRIBUTES]['options'] = {...this.departmentListData$, '': 'Default'};
                  }
              },
              () => {
              }
          );
      }
  }

  emitResetNode() {
    this.resetSelectedNode.emit();
  }

    setExtensions(data, extensionKey) {
       const extensions = this.layout.extension;
       extensions.attributes.options = {};
       const options = extensions.attributes.options;
       for (const key in data) {
           options[key] = data[key]['name'];
      }
      this.myDynamicForm.get('menu.payment.extension').setValue(extensionKey);
      this.selected = extensionKey;
    }

    scrollEvent = (event: any): void => {
        if (this.autoComplete && this.autoComplete.panelOpen) {
            this.autoComplete.updatePosition();

            const searchBlock = document.querySelector('.money-types-autocomplete-search-block') as HTMLElement;
            if (searchBlock) {
                const searchBlockData = searchBlock.getBoundingClientRect();
                if (searchBlockData.top < 185) {
                    this.autoComplete.closePanel();
                    const searchInput = document.querySelector('.money-types-autocomplete-search-block .search') as HTMLElement;
                    if (searchInput) {
                        searchInput.blur();
                    }
                }
            }
        }
    }

    filterMoneyTypes(value) {
        const filterValue = value.toLowerCase();
        if (this.chat2payAPIdata) {
            this.filteredOptions = filter(this.chat2payAPIdata.supportedCurrencies, option => {
                return option.name.toLowerCase().includes(filterValue);
            });
        }
    }

    setActiveMoneyType(value, setValue?) {
        if (this.chat2payAPIdata) {
            this.selectedMoneyType = find(this.chat2payAPIdata.supportedCurrencies, o => {
                return o.name === value;
            });
        }
        if (setValue && this.selectedMoneyType) {
            this.myDynamicForm.get(setValue).setValue(this.selectedMoneyType.iso);
            this.searchControl.setValue('');
            this.myDynamicForm.markAsDirty();
            this.myDynamicForm.markAsTouched();
        }
        this.activeSearchMoneyTypes = false;
    }

    validateList(layout) {
        if (layout.extension) {
            this.selected = layout['extension']['attributes']['options']['two'] === undefined ? 'one' : '';
        }
    }

    setActiveSearchMoneyTypes() {
        this.activeSearchMoneyTypes = !this.activeSearchMoneyTypes;
        if (this.activeSearchMoneyTypes) {
            // waiting for dom to update.
            setTimeout(() => {
                this.autoComplete['_element'].nativeElement.focus();
            }, 10);
        }
    }

    clearSearchForm() {
        this.searchControl.setValue('');
    }

  ngOnDestroy(): void {
    if (this.subscribedOptionData$ && !this.subscribedOptionData$.closed) {
      this.subscribedOptionData$.unsubscribe();
    }
    this.flowSubscription.unsubscribe();
    this.activeFormService.clearActiveForm();
    this.selectNodeTypesMapSubscription?.unsubscribe();
    this.channelSubscription?.unsubscribe();
      if (this.typeName === 'authenticate') {
          this.layout['authProvider'][ATTRIBUTES]['options'] = [];
      }
      if (this.typeName === 'chatdesk') {
          this.layout['sandboxIntegration'][ATTRIBUTES]['options'] = [];
          this.layout['productionIntegration'][ATTRIBUTES]['options'] = [];
          this.layout['department'][ATTRIBUTES]['options'] = [];
      }
    this.integrationSandboxListData$ = null;
    this.integrationProductionListData$ = null;
    this.departmentListData$ = null;
    this.idpListData$ = null;
  }

  canEditFlows(): boolean {
    if (this.isCurrentEnvProd || this.isFlowLocked || this.sharedService.isDeletePending) {
      return false;
    }
    return this.rolesService.canEditFlows();
  }

  canEditMenuTextOnly(): boolean {
    if (this.isCurrentEnvProd || this.isFlowLocked || this.sharedService.isDeletePending) {
      return false;
    }
    return this.rolesService.canEditMenuTextOnly();
  }

  canEdit(): boolean {
    if (this.isCurrentEnvProd || this.isFlowLocked || this.sharedService.isDeletePending) {
      return false;
    }
    return this.canEditFlows() || this.canEditMenuTextOnly();
  }

  displayChange(event: DisplayTypeModalData) {

      const displayTypeFormGroup: FormGroup = this.myDynamicForm.get('menu.menuParams.displayTypes')
      for (const channelId in event?.displayType) {
          const displayTypeValue = event?.displayType[channelId]
          if (displayTypeFormGroup.get(channelId)) {
              displayTypeFormGroup.get(channelId).setValue(displayTypeValue)
          } else {
              displayTypeFormGroup.addControl(channelId, new FormControl(displayTypeValue));
          }
      }

      if(event.isDirty) {
          this.myDynamicForm.get('menu.menuParams.displayTypes').markAsDirty();
      }
      this.myDynamicForm.get('menu.menuParams.customListButton').setValue(event?.customListButton);
  }

  focusFunction(event, label, path) {
    if (event && label !== '#') {
      const isPair = this.checkPairInputs(event.target.className);
      if (!isPair) {
        this.activeFormService.setPosition(event.target.id, path, event.target);
        this.activeFormService.setFocusStatus(event.target.id, path);
      }
    }
  }

  blurFunction(event) {
    if (this.myDynamicForm.dirty) {
      this.sharedService.setIsFlowChanged(false);
    }

    if (event?.relatedTarget) {
      const isField = find(event.relatedTarget.classList, (item) => {
        return item === 'dynamicField';
      });
      if (!isField) {
        setTimeout(() => {
          this.activeFormService.clearFocus();
        }, 100);
      }
    }
  }

  onInputChange() {
    const { status, dirty } = this.myDynamicForm;
    if (status === 'INVALID' || dirty) {
      this.sharedService.setIsFlowChanged(false);
    }
  }

  checkPairInputs(str) {
    const pair = str.search('keyValuePairValue');
    return pair !== -1;
  }

  resetData() {
    this.formValuePath = [];
    this.apiDetails = null;
    this.isFlowLocked = this.flowWebSocket.isFlowLocked(this.sharedService.getFlowRef);
    this.isCurrentEnvProd = this.sharedService.getEnvironment() === 'prod';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.typeName || changes.stepJson || changes.isFlowLocked) {
      this.resetData();
      this.nodeType = this.stepJson.type;
      const name = this.typeName;
      this.canEditState = this.canEditFlows();
      this.setupFormData(name);
      this.setFormData();
      this.optionData$ = this.getDataFromApi(this.dataToAdd['apiCall']);
      this.setNewValue();
      this.currentSteps = uniq(this.flowBuilder.getAllSteps);
      this.saveClicked = false;

      this.stepJson.valid = this.myDynamicForm.valid;
      this.flowBuilder.setNodeValid(this.stepTitle, this.myDynamicForm.valid);
      this.setAdditionalFormData(name);
      this.getC2P();

      const actionType = this.myDynamicForm.get('menu.menuParams.actionType');
      if (actionType) {
        actionType.setValue(this.selectedActionType);
      }
    }
      this.forceChangeDetection();
  }

  forceChangeDetection() {
      this.cdf.detectChanges();
  }

  getForm(value?) {
    let form;
    if (value) {
      form = this.formBuilder(value, this.layout).form;
    } else {
      form = this.formBuilder(this.localFormTypes[this.typeName].json, this.layout).form;
    }
    if (this.typeName === 'menuOption' || this.typeName === 'multipleChoice') {
      form.setValidators([validHeader()]);
    }
    return form;
  }

  private setupFormData(name: string) {
    this.json = Object.assign({}, this.localFormTypes[name].json);
    this.paths = Object.assign([], this.localFormTypes[name].paths);
    this.groups = Object.assign([], this.localFormTypes[name].groups);
    this.dataToAdd = Object.assign({}, this.localFormTypes[name].data);
    this.layout = Object.assign({}, this.localFormTypes[name].layout);
    this.myDynamicForm = this.getForm();
    this.dynamicData = this.localFormTypes[name];
    this.activeFormService.setActiveForm(this.myDynamicForm);
    this.activeFormService.setActiveFormNode(
      this.formBuilder(this.stepJson, this.layout).form.getRawValue()
    );
    this.validateList(this.layout);
  }

  private setNewValue() {
    if (this.typeName === 'authenticate') {
      if (this.initializeActionType === true) {
        this.initializeActionType = false;
        this.setFormData();
      }
    }
    const dataPath = this.dataToAdd['dataPath'];
    const groupPath = this.dataToAdd['groupPath'];
    const apiPath = this.dataToAdd['apiCall'];
    if (dataPath) {
      if (typeof dataPath === 'object') {
        for (const path of dataPath) {
          this.extractDataPath(path, groupPath, apiPath);
        }
      } else {
        this.extractDataPath(dataPath, groupPath, apiPath);
      }
    }
  }

  private extractDataPath(dataPath: string, groupPath: string, apiPath: string) {
    if (this.myDynamicForm.get(dataPath)) {
      const dataPathValue = this.myDynamicForm.get(dataPath).value;
      const controlName = this.getFormControlName(dataPath);
      if (this.typeName === 'displayMenu') {
        this.formValueChange(dataPathValue, controlName, dataPath);
        return;
      }

      if (dataPathValue.toString()) {
        if (groupPath) {
          const groupValue = this.getDataFromJson(this.getPath(groupPath)) as string;
          this.formValueChange(groupValue, controlName, dataPath);
        } else if (apiPath) {
          this.dropdownApiData(dataPathValue, controlName, dataPath);

          // Love my Hack its not as simple to solve this okay.
          this.subscribedOptionData$ = this.optionData$.subscribe((apis) => {
            const requestType = this.getDataFromJson([dataPathValue, 'requestType'], apis);
            if (requestType === 'multipart/form-data') {
              const path = 'action.actionParams.body.#';
              const pathArray = this.getPath(path);
              const formData = this.getDataFromJson(pathArray);
              const pathString = this.getPathString(path);
              const objectName = this.getFormControlName(pathString);

              this.resetGroup(pathString, objectName);
              let index = 0;
              for (const data in formData as Object) {
                if (this.getDataType(objectName) === 'keyValue') {
                  this.addKeyValue(pathArray);
                  this.myDynamicForm.get(`action.actionParams.body.${index}.key`).setValue(data);
                  this.myDynamicForm
                    .get(`action.actionParams.body.${index}.value`)
                    .setValue(formData[data]);
                  index++;
                }
              }
            }

            // this.apiDetails = this.getDataFromJson([dataPathValue], apis);
          });
        } else {
          this.formValueChange(dataPathValue, controlName, dataPath);
        }
      }
    }
  }

  setFormData() {
    if (this.stepJson) {
      const nodeData = this.formBuilder(this.stepJson, this.layout).form.getRawValue();
      this.setStepAnalyticSettings(this.stepJson);
      this.addDataToForm();
      this.activeFormService.setActiveFormNode(nodeData);
      if (this.typeName === 'authenticate' && this.initializeActionType === false) {
        const initializeValue = nodeData['menu']['menuParams']['actionType'];
        initializeValue !== '' ? this.selectedActionType = initializeValue : this.selectedActionType = 'authenticate';
        this.isAuthProviderPresent = false;
        this.initializeActionType = true;
      }

      if(nodeData.metadata && nodeData.metadata.stepUniqueID) {
        if(this.myDynamicForm.controls.metadata) {
          this.myDynamicForm.controls.metadata.controls = {
            ...this.myDynamicForm.controls.metadata.controls,
            stepUniqueID: new FormControl('', [])
          }
        } else {
          this.myDynamicForm.controls = {
            ...this.myDynamicForm.controls,
            metadata: new FormGroup({
               'stepUniqueID': new FormControl('', [])
            })
          }
        }
      }

      this.myDynamicForm.patchValue(nodeData);
      if (this.typeName === 'menuOption') {
          this.setDisplayType(nodeData);
      }
    }
  }

  setStepAnalyticSettings(stepData) {
      if (stepData.metadata) {
          if(stepData.metadata.reportingFeatures) {
              this.analyticsSettings = {
                  reportingFeatures: stepData.metadata.reportingFeatures,
                  reportingLabels: stepData.metadata.reportingLabels.reportingStepLabel
              }
          } else if(stepData.metadata.reportingLabels) {
              this.analyticsSettings = {
                  reportingLabels: stepData.metadata.reportingLabels.reportingStepLabel
              }
          }
      }

  }

  getFormControlName(path: string): string {
    const pathList = Object.assign([], path.split(PATH_SEPARATOR));
    return pathList.pop();
  }

  getFormGroupParent(path: string): FormGroup | FormArray {
    const pathName = this.getPath(path).join(PATH_SEPARATOR);
    try {
      if (pathName === 'menu.otp.resendInputs') {
        return this.myDynamicForm.get('menu.otp');
      }
      if (pathName === 'menu.menuParams.oauth2.scope') {
        return this.myDynamicForm.get('menu.menuParams.oauth2');
      }
      if (this.myDynamicForm.get(pathName).parent) {
        return this.myDynamicForm.get(pathName).parent;
      } else {
        console.warn('Missing form control: ', pathName);
      }
    } catch (e) {
      console.error('exception', e);
      console.warn('Missing form control: ', pathName);
    }
  }

  checkItemOptions(itemOptions) {
    return itemOptions !== 'keywords';
  }

  getFormGroup(path: string): FormGroup | FormArray {
    const pathName = this.getPath(path).join(PATH_SEPARATOR);
    return this.myDynamicForm.get(pathName);
  }

  getFromArrayGroup(path: string) {
    const pathName = this.getPath(path).join(PATH_SEPARATOR);
    return this.myDynamicForm.get(pathName);
  }

  getFormControlOptionsName(path: string): string {
    const pathList = Object.assign([], this.getPath(path));

    return pathList.pop();
  }

  getPath(path: string): Array<string> {
    return path
      .split(PATH_SEPARATOR)
      .filter((splitPath) => splitPath !== LIST_KEY && splitPath !== PLACEHOLDER);
  }

  getPathString(path: string): string {
    const filteredPath: string[] = this.getPath(path);
    return filteredPath.join(PATH_SEPARATOR);
  }

  getOptionFormGroup(path: Array<string>, key: string): AbstractControl | FormGroup {
    return this.myDynamicForm.get(this.createPath(path, key));
  }

  getformValue(form: FormGroup, controlName: string) {
      return form.get(controlName).value;
  }

  createPath(path: Array<string>, key?: string): string {
    if (key) {
      return path.join(PATH_SEPARATOR) + '.' + key.toString();
    } else {
      return path.join(PATH_SEPARATOR);
    }
  }

  changeFormGroupName(formPath: Array<string>, oldKey: string, newKey: string): void {
    this.changeData(formPath, oldKey, newKey);
  }

  getName(path: string[]): string {
    const tempPath = Object.assign([], path);
    return tempPath.pop();
  }

  reload() {
    this.show = false;
    setTimeout(() => (this.show = true), 1000);
  }

  toggleCheckHandler(e: any, id: string) {
    if (id === 'endSession') {
      let dataPath = this.dataToAdd['dataPath'];

            if (typeof dataPath === 'object') {
                for (const path of dataPath) {
                    if (path.includes(id)) {
                        dataPath = path;
                    }
                }
            }
            const controlName = this.getFormControlName(dataPath);

      this.formValueChange(e.checked, controlName, dataPath);
      this.flowBuilder.setNextStep(this.myDynamicForm.value.next);
    }
  }

  getDataType(value: string): DataTypes {
    if (this.layout) {
      if (this.layout[value]) {
        return this.layout[value].dataType;
      }
    }
  }

  addOption(path: string, objectName: string, key: string): void {
    const newPath = this.getPath(path);

    if (key === LIST_KEY) {
      key = this.getDataCount(newPath);
      this.currentIndex = +key - 1;
    }
    if (objectName === 'items') {
      this.addData(['menu', 'options', 'items'], this.getDataAttribute('items'), key);
      this.addData(
        ['menu', 'options', 'keywords'],
        this.getDataAttribute('keywords'),
        key,
        'array'
      );
    } else {
      key = objectName + key;
      this.addData(newPath, this.getDataAttribute(objectName), key);
    }
    this.getLogicWarning();
    // this.resetFormData();
  }

  addValue(path: Array<string>): void {
    const formArray = this.myDynamicForm.get(this.createPath(path)) as FormArray;
    formArray.push(this.fb.control(''));
  }

  addKeyValue(path: Array<string>): void {
    const formArray = this.myDynamicForm.get(this.createPath(path)) as FormArray;

    const dataToAddElement = this.dataToAdd[this.getFormControlName(this.createPath(path))];

    let key = '';
    let value = '';

    if (dataToAddElement) {
      key = dataToAddElement['key'] ? dataToAddElement['key'] : '';
      value = dataToAddElement['value'] ? dataToAddElement['value'] : '';
    }

    const layoutdKey = path.slice(-1)[0];
    formArray.push(
      this.fb.group({
        key: new FormControl(
          {
            value: key,
            disabled: this.isFieldDisabled(layoutdKey),
          },
          setValidation(this.layout[layoutdKey]['key'])
        ),
        value: new FormControl(
          {
            value: value,
            disabled: this.isFieldDisabled(layoutdKey),
          },
          setValidation(this.layout[layoutdKey]['value'])
        ),
      })
    );
  }

  addKeyObject(path: Array<string>): void {
    const formArray = this.myDynamicForm.get(this.createPath(path)) as FormArray;
    const formName = this.getFormControlName(this.createPath(path));
    formArray.push(
      this.fb.group({
        key: new FormControl({
          value: '',
          disabled: this.isFieldDisabled('result'),
        }),
        object: new FormGroup(this.keyObjectForm(this.dataToAdd[formName])),
      })
    );
  }

  getFormArrayValue(path: Array<string>): FormArray {
    if (this.formValuePath.indexOf(this.createPath(path)) === -1) {
      this.formValuePath.push(this.createPath(path));
    }
    try {
      return this.myDynamicForm.get(this.createPath(path)).value;
    } catch (e) {
      console.warn('Path not Found', path);
    }
  }

  setAuthProvider() {
    if (this.selectedActionType === 'authenticate') {
      this.selectedActionType = 'authenticate';
      this.formValueChange('authenticate', 'authType', 'menu.menuParams.actionType');
    }
    if (this.selectedActionType === 'logout') {
      this.selectedActionType = 'logout';
      this.formValueChange('logout', 'authType', 'menu.menuParams.actionType');
    }
    this.isAuthProviderPresent = true;
  }

  /**
   * Add new formControl.
   *
   * @param {string[]} path The path to where data needs to be added to.
   * @param {Object} dataObject The data new data Object structure.
   * @param {string} [name] The control name
   * @memberof JsonToFromComponent
   */
  addData(path: string[], dataObject: any, name?: string, type: string = 'group'): void {
    if (dataObject) {
      const pathString = this.createPath(path);
      const currentFormGroup: FormGroup = this.getFormGroup(pathString) as FormGroup;
      if (dataObject === PLACEHOLDER) {
        dataObject = {
          name: '',
        };
      }

      let newFormControl;

      if (type === 'group') {
        const tempGroup = {};
        for (const key in dataObject) {
          tempGroup[key] = new FormControl(
            {
              value: dataObject[key],
              disabled: this.isFieldDisabled(key),
            },
            setValidation(this.layout[key])
          );
        }

        newFormControl = this.fb.group(tempGroup);
        if (this.excludeValidatorList(pathString)) {
          newFormControl.controls['bodyText'].clearValidators();
        }
        currentFormGroup.addControl(name, newFormControl);
      } else {
        newFormControl = new FormControl([]);
        currentFormGroup.addControl(name, newFormControl);
      }
    }
  }

  excludeValidatorList(pathString: string): boolean {
    const excludePaths = ['menu.options.items'];
    const excludeTypes = ['menuOption', 'multipleChoice'];
    return excludePaths.includes(pathString) && excludeTypes.includes(this.typeName);
  }

  /**
   * Get FormGroup rawValue
   *
   * @param {string[]} path The path to the data you need.
   * @returns {Object}
   * @memberof JsonToFromComponent
   */
  getData(path: string[]): Object {
    const newPath = this.createPath(path);
    return this.myDynamicForm.get(newPath).getRawValue();
  }

  getViewData(path: string[]): Object {
    const newPath = this.createPath(path);
    // tslint:disable-next-line:radix
    const pathList = forEach(
      this.myDynamicForm.get(newPath).getRawValue(),
        // tslint:disable-next-line:radix
      (val, key) => (val.key = parseInt(key))
    );
    const pathArr = values(pathList);
    return pathArr;
  }

  changeData(path: string[], oldKey: string, newKey: string): void {
    if (newKey && newKey.length > 0) {
      const data = this.getData(path);
      data[newKey] = data[oldKey];
      delete data[oldKey];
    }
    this.myDynamicForm = this.getForm(this.json);
  }

  getDataCount(path: string[]): string {
    return (Object.keys(this.getData(path)).length + 1).toString();
  }

  getDataAttribute(objectName: string): Array<any> | Object {
    if (objectName in this.dataToAdd) {
      return this.dataToAdd[objectName];
    }
    return null;
  }

  saveNodeClicked() {
    if (this.myDynamicForm.valid) {
      // this.sanitizeRawData();
      let value = this.myDynamicForm.getRawValue();
      if (this.formValuePath.length > 0) {
        value = this.updateForData(this.myDynamicForm, this.formValuePath);
      }
      value.valid = this.myDynamicForm.valid;
      if(!value.metadata) value = {...value, metadata: {}} 
      if(value.metadata && this.analyticsSettings) {
        if(!isEmpty(this.analyticsSettings.reportingFeatures)) {
          value.metadata = {
            ...value.metadata,
            reportingFeatures: this.analyticsSettings.reportingFeatures,
          }
        } else {
          delete value.metadata.reportingFeatures;
        }

        if(this.analyticsSettings.reportingLabels !== '') {
          value.metadata = {
            ...value.metadata,
            reportingLabels: {
              reportingStepLabel: this.analyticsSettings.reportingLabels
            }
          }
        } else {
          if(!value.metadata.reportingLabels)
          delete value.metadata.reportingLabels;
        }
      }
      this.addWaSettings(value);
      this.saveNode.emit(value);
      this.sharedService.setIsFlowChanged(true);
      this.activeFormService.setNodeExit(false);
    } else {
      this.saveClicked = true;
      swalMini({
        title: 'Validation failed, please check for errors!',
        type: 'error',
      });
      this.sharedService.setIsFlowChanged(false);
    }
  }

    addWaSettings(step) {
        if (!this.waSettings) {
            return step;
        }
        step.metadata['conversion'] = this.waSettings;
        return step;
    }

  openAnalyticsOverlayOnNode() {
    this.analyticsSettingsOverlay.analyticsSlider.nativeElement.style.right = '0%';
    this.isLeftVisible = true;
    this.showAnalyticsForm = true;
    this.isTrackNodeOverlayOpen = true;
    document.getElementById('formBody').scrollTop = 0;
  }

  onCloseCustomMsgSlider() {
    this.analyticsSettingsOverlay.analyticsSlider.nativeElement.style.right = '-100%';
    this.isLeftVisible = false;
    this.showAnalyticsForm = false;
    this.isTrackNodeOverlayOpen = false;
  }

  openDeleteParentNodeDialog() {
    if (!this.isRecycleBinItem) {
      if (
        this.userStore.getMessageDisplay === null ||
        this.userStore.getMessageDisplay === undefined
      ) {
        this.userStore.setMessageDisplay = false;
      }

      this.displayMessage = this.userStore.getMessageDisplay;
      if (this.displayMessage.toString() === 'false') {
        this.childCount = this.deleteChildNodeClicked();
        if (this.childCount > 0) {
          this.dialog.open(this.deleteParentNodeDialog, {
            panelClass: 'deleteParentNodeDialog',
            width: '484px',
            height: '365px',
            disableClose: true,
          });
        } else {
          this.deleteNodeClicked();
        }
      } else {
        this.deleteNodeClicked();
      }
    } else {
      this.deleteNodeClicked();
    }
  }

  deleteNodeClicked() {
    this.deleteNode.emit(this.stepTitle);
    this.dialog.closeAll();
  }

  setDisplay(event) {
    if (event.checked === undefined || event.checked === null) {
      this.userStore.setMessageDisplay = false;
    } else {
      this.userStore.setMessageDisplay = event.checked;
    }
  }

  deleteChildNodeClicked(): any {
    return this.flowBuilder.getChildrenCount(this.stepTitle);
  }

  closeModal() {
    this.dialog.closeAll();
  }

  updateForData(formValue: FormGroup, keyValueList: Array<string>): Object {
    const rawValue = Object.assign({}, formValue.getRawValue());
    for (const path of keyValueList) {
      let newFormValue: Object = {};
      const formArrayValue = formValue.get(path).value;
      const controlName = this.getFormControlName(path);
      switch (this.getDataType(controlName)) {
        case 'keyValue':
          newFormValue = setKeyValueToForm(formArrayValue);
          break;
        case 'keyObject':
          newFormValue = setKeyObjectToForm(formArrayValue);
          break;
      }
      setData(path, rawValue, newFormValue);
    }
    return rawValue;
  }

  getAttributeValue(layoutName: string, attributeName: string): boolean | Object {
    if (this.layout && this.layout[layoutName]) {
      if (
        ATTRIBUTES in this.layout[layoutName] &&
        attributeName in this.layout[layoutName][ATTRIBUTES]
      ) {
        return this.layout[layoutName][ATTRIBUTES][attributeName];
      }
    }

    return false;
  }

  // If node type is oauth -> based on actionType component value we should get proper form
  getOAuthNodeDataPath(currDataKey: string, key: string): { stepData: string; path: string } {
      const tempObjectKey = currDataKey === 'logout' ? '-' : 'oauth2';
      const stepData = this.dataToAdd[key][this.selectedActionType][tempObjectKey].json;
      const path = this.dataToAdd[key][this.selectedActionType][tempObjectKey].groups;

    return { stepData, path };
  }

  formValueChange(dataKey: string, key: string, myPath: string) {

    if (key === 'authProvider') {
      // Behaviour when authProvider is set to default
      this.isAuthProviderPresent = false;
    }

    if (key === 'authType' && dataKey === '-') {
      dataKey = this.selectedActionType;
    }

    if (key === 'extension') {
      this.setChat2payDataFromAPI(this.chat2payAllAPIData, dataKey);
    }

    let dataLayout = '';
    key !== 'authType' ? dataLayout = this.layout[key][ATTRIBUTES] : dataLayout = this.layout['authProvider'][ATTRIBUTES];
    const currDataKey = dataKey === null ? '' : dataKey;
    if (dataLayout && dataLayout['data']) {
      let newStepData = null;
      let newPath = null;
      // Switch form for oAuth node slider
      if (key === 'authType') {
        const { stepData, path } = this.getOAuthNodeDataPath(currDataKey, 'authType');
        newStepData = stepData;
        newPath = path;
        this.myDynamicForm.get('menu.menuParams.actionType').setValue(this.selectedActionType);
      } else {
        // keep previous behavior
        newStepData = this.getDataFromJson([key, currDataKey.toString(), 'json'], this.dataToAdd);
        newPath = this.getDataFromJson([key, currDataKey.toString(), 'groups'], this.dataToAdd);
      }
      if (this.dataToAdd && newStepData && newPath) {
        const prevDynamicFormValue = this.myDynamicForm.value;
        this.myDynamicForm = this.getForm(newStepData);
        this.groups = newPath;
        this.setFormData();
        this.setValuesToFormWhenUpdate(prevDynamicFormValue, this.myDynamicForm.value);
        if (dataLayout['type'] !== 'group' && dataLayout['type'] !== 'api') {
          this.myDynamicForm.get(myPath).setValue(currDataKey);
        }
      }
    }
    if (currDataKey === 'encode' && key === 'algorithm') {
      const parent = this.myDynamicForm.get(myPath).parent;
      if (parent && parent.get('encoding') && parent.get('algorithm')) {
        parent.get('encoding').setValue(parent.get('algorithm').value);
      }
    }
    this.activeFormService.setActiveForm(this.myDynamicForm);
  }

  setValuesToFormWhenUpdate(oldData: object, newData: object): void {
    if (diff(oldData, newData)) {
      map(diff(oldData, newData), (item) => {
        if (hasIn(oldData, item) && hasIn(newData, item)) {
          if (this.shouldSetValue(item)) {
            this.myDynamicForm.get(item).setValue(get(oldData, item));
          }
        }
      });
    }
  }

  shouldSetValue(item): boolean {
    if (this.typeName !== 'media') {
      return true;
    }
    const mediaExclusionList = ['menu.text'];
    return !mediaExclusionList.includes(item);
  }

  dropdownGroupChange(dataKey: any, key: string, myPath: string) {
    const label = dataKey.selected.id;
    this.formValueChange(label, key, myPath);
    this.myDynamicForm.get('action.actionParams.method').setValue(label.toLowerCase());
    this.myDynamicForm.get(myPath).setValue(dataKey.value);
  }

  dropdownApiData(dataKey: string, key: string, myPath: string) {
    const nodeData = this.formBuilder(this.stepJson, this.layout).form.getRawValue();
    const actionParams = nodeData.action
      ? nodeData.action.actionParams
        ? nodeData.action.actionParams
        : null
      : null;
    const defPath = 'action.actionParams';
    const value = this.getAttributeValue(key, 'value') as string;
    if (value) {
      this.subscribedOptionData$ = this.optionData$.subscribe((apis) => {
        const newDataKey = this.getDataFromJson([dataKey, value], apis);
        const requestType = this.getDataFromJson([dataKey, 'requestType'], apis);
        if (newDataKey) {
          // Not sure what this does but its gone now 😂
          // this.stepJson = this.myDynamicForm.getRawValue();
          if (requestType === 'multipart/form-data') {
            this.updateLayout('apiName', 'FORMDATA', 'body');
            this.formValueChange('FORMDATA', key, myPath);
          } else {
            this.formValueChange(newDataKey, key, myPath);
          }
        }
        this.apiDetails = this.getDataFromJson([dataKey], apis);
        const apiName = this.myDynamicForm.get(`${defPath}.apiName`).value;

        if (apis && !apis.hasOwnProperty(apiName)) {
            this.flowBuilder.setNodeValid(this.stepTitle, false);
            this.myDynamicForm.get(`${defPath}.apiName`).setErrors({'validApi': 'Please select an API'});
        } else {
            this.myDynamicForm.get(`${defPath}.apiName`).setErrors(undefined);
        }

        if (this.apiDetails && requestType !== 'multipart/form-data') {
          const sameApiName =
            actionParams.apiName === apiName;
          if (actionParams && sameApiName) {
            this.myDynamicForm.get(`${defPath}.body`).setValue(actionParams.body);
          }
          if (this.myDynamicForm.get(myPath).value !== dataKey) {
            this.myDynamicForm.get(myPath).setValue(dataKey);
          }
          this.activeFormService.setActiveForm(this.myDynamicForm);
        }
      });
    }
  }

  addToArrayIndx(arrayToUpdate: string[], arrayToAdd: string[], indexToAddTo: number): string[] {
    const startOfArray = Object.assign([], arrayToUpdate.slice(0, indexToAddTo));
    const endOfArray = Object.assign([], arrayToUpdate.slice(indexToAddTo, arrayToUpdate.length));
    return startOfArray.concat(arrayToAdd).concat(endOfArray);
  }

  addDataToForm() {
    const dataPath = getAllIndexes(this.paths, '#');
    if (dataPath.length !== 0) {
      for (const path of dataPath) {
        const pathArray = this.getPath(path);
        const formData = this.getDataFromJson(pathArray);
        const pathString = this.getPathString(path);
        const key = this.getFormControlName(path);
        const objectName = this.getFormControlName(pathString);

        switch (this.getDataType(objectName)) {
          case 'keyObject':
            this.resetGroup(pathString, objectName);
            for (const data in formData as Object) {
              this.addKeyObject(pathArray);
            }
            break;
          case 'keyValue':
          case 'item':
          case 'keyword':
            this.resetGroup(pathString, objectName);
            for (const data in formData as Object) {
              if (this.getDataType(objectName) === 'keyValue') {
                this.addKeyValue(pathArray);
              } else {
                this.addOption(pathString, objectName, key);
              }
            }
            break;
          case 'array':
            this.resetGroup(pathString, objectName);
            for (const x in formData) {
              this.addValue(pathArray);
            }
            break;
          default:
            console.warn('Unsupported data type', this.getDataType(objectName));
            break;
        }
      }
    }
  }

  resetGroup(path: string, name: string) {
    const parentControl = this.getFormGroupParent(path) as FormGroup;
    if (name === 'items') {
      parentControl.removeControl('items');
      parentControl.removeControl('keywords');
      parentControl.addControl('items', this.fb.group({}));
      parentControl.addControl('keywords', this.fb.group([]));
    } else {
      parentControl.removeControl(name);
      if (
        this.getDataType(name) === 'keyValue' ||
        this.getDataType(name) === 'array' ||
        this.getDataType(name) === 'keyObject'
      ) {
        parentControl.addControl(name, this.fb.array([]));
      } else {
        parentControl.addControl(name, this.fb.group({}));
      }
    }
  }

  getDataFromJson(path: string[], data?: Object): any {
    data = data ? data : Object.assign({}, this.stepJson);
    for (const walk of path) {
      if (data && data[walk]) {
        if (data[walk].method === 'GET') {
          delete data[walk].requestType;
        }


        data = data[walk];
      } else {
        return null;
      }
    }
    return data;
  }

  trackByItem(index, item) {
    return index;
  }

  itemToPath(items: Object) {
    const path: string[] = [];

    forEach(items, (value, key) => {
      if (key !== 'key' && key !== 'next') {
        path.push(key);
      }
    });
    path.push('keywords');
    if (items['next'] !== null && items['next'] !== undefined) {
      path.push('next');
    }
    if (items['flowId'] !== null && items['flowId'] !== undefined) {
      path.push('flowId');
    }
    return path;
  }

  getDataFromApi(apiName: string) {
    if (apiName === 'getApis') {
      return this.flowManagerService.getApis();
    }
  }

  /**
   * builds a FormGroup For a json step.
   *
   * @param {Step} currentStep
   * @param layout the Field layout
   * @returns {MyFormBuilder}
   */
  formBuilder(currentStep: Step, layout: any): MyFormBuilder {
    const form = {};
    for (const key in currentStep) {
      if (currentStep.hasOwnProperty(key)) {
        let fieldValue =  currentStep[key];
        if (
          typeof fieldValue === 'string' ||
          typeof fieldValue === 'number' ||
          typeof fieldValue === 'boolean'
        ) {
          form[key] = new FormControl(
            {
              value: fieldValue,
              disabled: this.isFieldDisabled(key),
            },
            setValidation(layout[key])
          );
        } else if (typeof fieldValue === 'object' && !this.getDataType(key)) {
          const formValue: MyFormBuilder = this.formBuilder(fieldValue, layout);
          form[key] = formValue.form;
        } else {
          switch (this.getDataType(key)) {
            case 'keyValue':
              form[key] = new FormArray(this.keyValuePairForm(currentStep[key], key));
              break;
            case 'keyObject':
              form[key] = new FormArray(this.keyObjectPairForm(currentStep[key], key));
              break;
            case 'array':
              const arrayControl = [];
              for (const subKey in fieldValue) {
                arrayControl.push(new FormControl(fieldValue[subKey]));
              }
              form[key] = new FormArray(arrayControl);
              break;
            case 'keyword':
            case 'item':
              const control = {};
              for (const subKey in fieldValue) {
                if (fieldValue[subKey] && fieldValue[subKey].flowId) {
                  const { text, flowId } = fieldValue[subKey];
                  control[subKey] = { text, next: flowId };
                } else {
                  control[subKey] = fieldValue[subKey];
                }
              }
              form[key] = new FormControl({
                value: control,
                disabled: this.isFieldDisabled(key),
              });
              break;
            default:
              console.warn('Data type was not found');
          }
        }
      }
    }

    return {
      form: new FormGroup(form),
    };
  }

  addSeparator(valueInput, arrayAttributes) {
    if (valueInput !== '') {
      arrayAttributes.push(valueInput);
    }
  }

  keyValuePairForm(data: {}, fieldKey: string): AbstractControl[] {
    const keyValueArray: Array<AbstractControl> = [];
    for (const key in data) {
      const keyValuePair = new FormGroup({
        key: new FormControl({
          value: key,
          disabled: this.isFieldDisabled(fieldKey),
        }),
        value: new FormControl({
          value: data[key],
          disabled: this.isFieldDisabled(fieldKey),
        }),
      });
      keyValueArray.push(keyValuePair);
    }
    return keyValueArray;
  }

  keyObjectPairForm(data: Object, fieldKey: string): AbstractControl[] {
    const keyObjectArray: Array<AbstractControl> = [];
    for (const key in data) {
      const keyObjectPair = new FormGroup({
        key: new FormControl({
          value: key,
          disabled: this.isFieldDisabled(fieldKey),
        }),
        object: new FormGroup(this.keyObjectForm(data[key])),
      });
      keyObjectArray.push(keyObjectPair);
    }
    return keyObjectArray;
  }

  keyObjectForm(data: Object): {} {
    const formObject = {};
    for (const key in data) {
      formObject[key] = new FormControl({
        value: data[key],
        disabled: this.isFieldDisabled(key),
      });
    }
    return formObject;
  }

  isDisabled(path: string): Boolean {
    const formData = this.myDynamicForm.get(path);
    return formData.disabled || this.isResultFieldReadOnly(path);
  }

  isResultFieldReadOnly(path: string): Boolean {
    const formData = this.myDynamicForm.get(path);
    return (
      path.includes(this.RESULT_FIELD) &&
      (formData.value === this.RESULT_YES ||
        formData.value === this.RESULT_NO ||
        formData.value === this.RESULT_ERROR ||
        formData.value === this.RESULT_OTHER ||
        formData.value === this.RESULT_TIMEOUT ||
        formData.value === this.RESULT_MAX_CONNECTIONS)
    );
  }

  removeFormArray(path: Array<string>, name: string, index: number) {
    const parentControl = this.getFormGroupParent(this.createPath(path)) as FormGroup;
    const itemControl = parentControl.get(name) as FormArray;
    if (itemControl.length > 1 || (this.typeName === 'httpCall' && name !== 'result')) {
      itemControl.removeAt(index);
    } else {
      swalMini({ title: 'At least one option needed', type: 'error' });
    }
  }

  removeFormControl(path: Array<string>, name: string, index: string) {
    const parentControl = this.getFormGroupParent(this.createPath(path)) as FormGroup;
    const itemControl = parentControl.get(name) as FormGroup;
    const newIndex = index + 1;

    if (Object.keys(itemControl.getRawValue()).length > 1) {
      itemControl.removeControl(newIndex);

      const itemControlValue = itemControl.getRawValue();

      const oldData = this.myDynamicForm.getRawValue();
      let newData = this.removeSetData(itemControlValue, path, oldData);

      if (name === 'items') {
        const keywordControl = parentControl.get('keywords') as FormGroup;
        keywordControl.removeControl(index + 1);
        newData = this.removeSetData(
          keywordControl.getRawValue(),
          ['menu', 'options', 'keywords'],
          newData
        );
      }

      this.stepJson = newData;

      this.setFormData();
    } else {
      swalMini({ title: 'At least one option needed', type: 'error' });
    }
  }

  private removeSetData(itemControlValue, path: Array<string>, data: {}) {
    const newItemControl = {};
    for (const [itemIndex, item] of Object.keys(itemControlValue).entries()) {
      newItemControl[itemIndex + 1] = itemControlValue[item];
    }

    setData(this.createPath(path), data, newItemControl);
    return data;
  }

  onSpaceKeyDown(e) {
    e.stopPropagation();
  }

  onEnterKeyDown(e, value, attributes) {
    e.stopPropagation();
    this.addSeparator(value, attributes);
  }

  onScrollHandler() {
    const statuses = this.activeFormService.getStatuses();
    if (statuses.focus) {
      const element: any = document.querySelector(`#${statuses.focus}`);
      if (element) {
        const viewportOffset = element.getBoundingClientRect();
        const top = viewportOffset.top;
        const variable = document.querySelector('#variable_container') as HTMLElement;
        if (variable) {
          const varTop = variable.getBoundingClientRect().top;
          if (varTop !== top) {
            variable.style.top = `${top}px`;
          }
        }
      }
    }
  }

  getAutocompleteOptions(options) {
    const menu = this.myDynamicForm.get('menu');
    if (menu) {
      const formOptions = menu.get('options');
      if (formOptions && formOptions.value) {
        const separator = find(options, (s) => s === formOptions.value.optionSeperator);
        if (!separator && formOptions.value.optionSeperator) {
          options.push(formOptions.value.optionSeperator);
        }
      }
    }
    return options;
  }

  getLayoutActionType() {
    const { json } = this;
    if (json.type === 'action' && json.action) {
      return json.action.actionType;
    }
    return '';
  }

  updateLayout(dataKey, layoutKey, dataName) {
    const currentLayout = this.layout;
    currentLayout[dataName] = this.dataToAdd[dataKey][layoutKey]['layout'][dataName];
    this.layout = currentLayout;
  }

  checkErrors(myPath) {
    return (
      this.saveClicked ||
      (this.myDynamicForm.get(myPath).errors && this.myDynamicForm.get(myPath).touched) ||
      (this.activeFormService.getNodeExit() && this.myDynamicForm.get(myPath).errors) ||
      this.myDynamicForm.get(myPath).dirty
    );
  }

  checkMediaNodeSandbox(controlName) {
    const menu = this.stepJson.menu;
    if (
      controlName === 'varName' &&
      this.typeName === 'media' &&
      menu &&
      menu.menuType === 'media'
    ) {
      return true;
    }
    return false;
  }

  sanitizeRawData() {
    for (const path of this.paths) {
      if (this.getFormControlName(path) === LIST_KEY) {
        const pathString = this.getPathString(path);
        const objectName = this.getFormControlName(pathString);
        const dataType = this.layout[objectName].dataType;
        for (const index of Object.keys(this.myDynamicForm.get(pathString).controls)) {
          if (dataType === 'keyValue' || dataType === 'keyObject') {
            this.sanitizeRawDataValue(`${pathString}.${index}.key`);
          } else {
            for (const dataKey in this.dataToAdd[objectName]) {
              this.sanitizeRawDataValue(`${pathString}.${index}.${dataKey}`);
            }
          }
        }
        return;
      }

      this.sanitizeRawDataValue(path);
    }
  }

  sanitizeRawDataValue(dataPath: string) {
    const pathValue = this.myDynamicForm.get(dataPath).value;
    // const sanitizedData = decode(this.sanitizer.sanitize(SecurityContext.HTML, pathValue));
    // this.myDynamicForm.get(dataPath).setValue(sanitizedData)
  }

  collapseExpandLogicItems() {
    this.collapsed ? this.accordion.openAll() : this.accordion.closeAll();
    this.collapsed = !this.collapsed;
  }

  getCollapseTooltip() {
    return this.collapsed ? 'Expand all options' : 'Collapse all options';
  }

  getLogicItemTitle(index) {
    const value = this.myDynamicForm.getRawValue();
    const separator = value.menu.options.optionSeperator;
    const description = this.myDynamicForm.get('menu.options.items.' + index + '.text').value;
    return separator + description;
  }

  drop(path, e) {
    const keywordsPath = ['menu', 'options', 'keywords'];
    const list: any = this.getViewData(path);
    const keywordsList: any = this.getViewData(keywordsPath);

    const items = this.moveItem(list, e.previousIndex, e.currentIndex);
    const keywords = this.moveItem(keywordsList, e.previousIndex, e.currentIndex);

    const newPath = this.createPath(path);
    this.myDynamicForm.get(newPath).setValue(items);
    this.myDynamicForm.get('menu.options.keywords').setValue(keywords);
  }

  canDrop(): boolean {
    return document.getElementsByClassName("select-flow-step-container").length !== 0;
  }

  moveItem(list, prevIndex, nextIndex) {
    moveItemInArray(list, prevIndex, nextIndex);
    const data = {};
    map(list, (o, i) => {
      delete o.key;
      data[i + 1] = o;
    });
    return data;
  }

  setImageRef(event, name) {
    name.setValue(event);
  }

  getImageRef(value) {
    return value;
  }

  toggleChange(value) {
    this.mediaValueType = value;
    if (this.myDynamicForm.get('menu.menuParams.varType')) {
      this.myDynamicForm.get('menu.menuParams.varType').setValue(value);
    }

    if (this.mediaValueType === 'API') {
      this.varNameAssets = this.myDynamicForm.get('menu.input.varName').value;
      if (this.varNameAssets === '') {
        this.myDynamicForm.get('menu.input.varName').setValue(this.varNameAPI);
      }
    } else if (this.mediaValueType === 'Assets') {
      this.varNameAPI = this.myDynamicForm.get('menu.input.varName').value;
      this.myDynamicForm.get('menu.input.varName').setValue(this.varNameAssets);
    }
  }

  getMediaValueType() {
    if (this.myDynamicForm.get('menu.menuParams.varType')) {
      this.mediaValueType = this.myDynamicForm.get('menu.menuParams.varType').value;
    }

    return this.mediaValueType;
  }

  getMediaValue(value: string): string {
    if (value) {
      if (new RegExp('^\\[\\[[\\w\\s\\W]+\\]\\]$').test(value)) {
        this.mediaValueType = 'API';
        return 'API';
      }
    }
    this.mediaValueType = 'Assets';
    return 'Assets';
  }

  checkMediaDirectionValue() {
    return this.myDynamicForm.get('menu.media-direction')
      ? this.myDynamicForm.get('menu.media-direction').value
      : '';
  }

    setAdditionalFormData(name) {
        switch (name) {
            case 'media':
                this.getMediaValue(this.myDynamicForm.get('menu.input.varName').value);
                break;
        }
    }

  private setDisplayType(nodeData: any) {
        if (nodeData && nodeData['menu']['menuParams']['displayTypes']) {
            const displayType = nodeData['menu']['menuParams']['displayTypes'] ? nodeData['menu']['menuParams']['displayTypes'] : {};
            const customListButton = nodeData['menu']['menuParams']['customListButton'] ? nodeData['menu']['menuParams']['customListButton'] : '';
            this.displayTypeModalData = {
                isDirty: false,
                displayType,
                customListButton
            }
            if (!isEmpty(displayType)) {
                this.displayChange(this.displayTypeModalData);
            }
        }

  }

    getC2P() {
      if (this.typeName === 'chat2pay' && this.chat2payAPIdata === null) {
        this.chat2PayHasError = true
        this.loadingInProgress = true;
        this.flowManagerService.getChat2PayExtensions().pipe(
            // tslint:disable-next-line:no-shadowed-variable
            tap((resp: any) => {
                  if (resp.status === 200) {
                    this.chat2payAllAPIData = resp.body;
                    const paymentExtension = this.stepJson && this.stepJson.menu && this.stepJson.menu.payment && this.stepJson.menu.payment.extension;
                    const key = paymentExtension && resp.body.hasOwnProperty(this.stepJson.menu.payment.extension)
                        ? this.stepJson.menu.payment.extension
                        : Object.keys(resp.body)[0];
                    this.setChat2payDataFromAPI(resp.body, key);
                    this.setExtensions(resp.body, key);
                    this.chat2PayHasError = false
                  } else {
                    this.chat2payAPIdata = null;
                    this.chat2payAllAPIData = null;
                  }
                  this.loadingInProgress = false;
                }
            ))
            .subscribe(
                () => {
                },
                () => {
                  this.loadingInProgress = false;
                  this.chat2payAPIdata = null;
                  this.chat2payAllAPIData = null;
                }
            );
      }
    }

    setChat2payDataFromAPI(data, key) {
      const responseBody = data[key];
      this.chat2payAPIdata = responseBody;
      this.selectedMoneyType = find(responseBody.supportedCurrencies, (o) => {
        return o.isDefault;
      });

      this.myDynamicForm.get('menu.menuParams.apiToken').setValue(responseBody.apiKey);
        // tslint:disable-next-line:no-unused-expression
      this.selectedMoneyType ? this.myDynamicForm.get('menu.payment.currencyCode').setValue(this.selectedMoneyType.iso) : '';
      this.filteredOptions = responseBody.supportedCurrencies;
    }

  getLabel(labels) {
    const labelValue = this.myDynamicForm.get(labels.path).value;
    return labels.values[labelValue];
  }

  getType(field) {
    let type = field ? field.type : '';
    if (field.attributes && field.attributes.types) {
      const types = field.attributes.types;
      const labelValue = this.myDynamicForm.get(types.path).value;
      type = types.values[labelValue];
    }

     return type;
    }

    checkCurrencyTypeValue() {
        if (this.myDynamicForm.get('menu.payment.currency')) {
            if (this.myDynamicForm.get('menu.payment.currency').value === 'predefined') {
                this.predefinedType();
            } else {
                this.variableType();
            }
            return this.myDynamicForm.get('menu.payment.currency').value;
        }
        return '';
    }

    variableType() {
        if (this.currencyType === 'predefined' && this.myDynamicForm.get('menu.payment.currencyCode').value !== '') {
            this.predefineValue = this.myDynamicForm.get('menu.payment.currencyCode').value;
            if (this.variableValue !== '') {
                this.myDynamicForm.get('menu.payment.currencyCode').setValue(this.variableValue);
                this.variableValue = '';
            } else {
                this.myDynamicForm.get('menu.payment.currencyCode').setValue('');
                this.variableValue = '';
            }
        }
        this.currencyType = 'variable';
    }

     predefinedType() {
        if (this.predefineValue !== '') {
            this.variableValue = this.myDynamicForm.get('menu.payment.currencyCode').value;
            this.myDynamicForm.get('menu.payment.currencyCode').setValue(this.predefineValue);
            this.predefineValue = '';
        }

        if (this.chat2payAPIdata) {
            this.selectedMoneyType = find(this.chat2payAPIdata.supportedCurrencies, o => {
                return o.iso === this.myDynamicForm.get('menu.payment.currencyCode').value;
            });
        }

        if ((this.selectedMoneyType === null || this.selectedMoneyType === undefined) && this.chat2payAPIdata) {
            this.selectedMoneyType = find(this.chat2payAPIdata.supportedCurrencies, o => {
                return o.isDefault;
            });

            if ((this.selectedMoneyType === null || this.selectedMoneyType === undefined) && this.chat2payAPIdata) {
                this.selectedMoneyType = this.chat2payAPIdata.supportedCurrencies[0].iso;
                this.myDynamicForm.get('menu.payment.currencyCode').setValue(this.selectedMoneyType);
            }
        }
        this.currencyType = 'predefined';
    }

    getKeyTextValue(path) {
        const pathArr = path.split('.');
        return pathArr[pathArr.length - 2];
    }

  getWhatsAppDisplayType() {
    return this.channelDisplayType.charAt(0).toUpperCase() + this.channelDisplayType.slice(1);
  }

  checkOptionsMaxLength(channelId?: number, displayName?: string) {
    const channel =  channelId ? channelId : this.selectedChannel;
    const name = displayName ? displayName : this.channelDisplayType;
    return this.displayService.checkOptionsMaxLength(name, channel);
  }

  // TODO: is this still needed check pls
  getLogicWarning() {
    const data = this.displayService.getLogicWarning(this.currentIndex + 1, this.myDynamicForm.get('menu.menuParams.displayTypes').value);
    this.toolTipText = data.toolTipText;
    this.channelDisplayType = data.options;
    this.warningCondition = data.condition;
  }

  checkOptionsMaxLengthInvalid(channelId?: number): boolean {
    const options = this.myDynamicForm.get('menu.options.items');
    if (displayTypeChannels.includes(channelId)) {
      const displayType = this.myDynamicForm.get('menu.menuParams.displayTypes').value[channelId];
      const isValid = this.displayService.checkOptionsMaxLengthInvalid(options, displayType, channelId);
      this.message = this.displayService.buildMessage();
      this.currentIndex = values(options.value).length;
      return isValid;
    }
    return false;
  }

  onErrorTriggered(isError: boolean) {
      this.flowBuilder.setNodeValid(this.stepTitle, !isError);
    }

  blurSearchMoneyType() {
      setTimeout(() => {
          this.activeSearchMoneyTypes = false;
      }, 200);
  }

  setGroupClass(group) {
    const keys = this.objectKeys(group);
    if (keys) {
      return `${keys.join(' ').toLowerCase()} ${this.typeName}-group`;
    }
    return '';
  }

  isFieldDisabled(fieldKey: string): Boolean {
    const canEditFlows: Boolean = this.canEditFlows();
    const canEditMenuTextOnly: Boolean = this.canEditMenuTextOnly();
    if (canEditFlows || (canEditMenuTextOnly && editMenuTextOnlyFieldKeys.includes(fieldKey))) {
      return false;
    }

    if (this.layout[fieldKey] && this.layout[fieldKey].attributes) {
      return this.layout[fieldKey].attributes.readonly ? this.layout[fieldKey].attributes.readonly : false;
    }
    return true;
  }

  buildCMSConditions(type: string, field: string, channelId: number, size?: string): CMSConditions {
    return {
      channelId: channelId,
      field: field,
      size: size,
      type: type
    };
  }

    getMenuType() {
        return this.dynamicData.json['menu'].menuType;
    }

    saveAnalyticsSettings() {
      this.onCloseCustomMsgSlider();
    }

    updateAnalyticsSettings(updatedSettings: any) {
      this.isTrackNodeOverlayOpen = false;
      this.analyticsSettings = updatedSettings;
      this.onCloseCustomMsgSlider();
    }

    getCurrentCollections() {
     this.collectionService.getCollections().subscribe((response) => {
           const collections = response as CollectionItem[];
           this.collectionItems = collections.filter(collection => !collection.disabled);
      });
    }

    openWaOverlay() {
        this.whatsAppSettingsOverlay.slider.nativeElement.style.right = '0%';
        this.whatsAppSettingsOverlay.isOpen = true;

        this.isLeftVisible = true;
        this.showAnalyticsForm = true;
        this.isTrackNodeOverlayOpen = true;
    }

    closeWaOverlay() {
        this.whatsAppSettingsOverlay.slider.nativeElement.style.right = '-110%';
        this.whatsAppSettingsOverlay.isOpen = false;

        this.isLeftVisible = false;
        this.showAnalyticsForm = false;
        this.isTrackNodeOverlayOpen = false;
    }

    updateWaSettings(settings) {
        this.waSettings = settings;
        this.closeWaOverlay();
    }
}

function setKeyValueToForm(formArrayValue: any): Object {
  const newFormValue: Object = {};
  for (const keyValue of formArrayValue) {
    const sanitizeKey = keyValue['key'];
    const sanitizeValue = keyValue['value'];

    newFormValue[sanitizeKey] = sanitizeValue;
  }
  return newFormValue;
}

function setKeyObjectToForm(formArrayValue: any): Object {
  const newFormValue: Object = {};
  for (const keyObject of formArrayValue) {
    const valueObject = {};
    for (const key in keyObject['object']) {
      const sanitizeKey = key;
      const sanitizeValue = keyObject['object'][key];

      valueObject[sanitizeKey] = sanitizeValue;
    }
    newFormValue[keyObject['key']] = valueObject;
  }
  return newFormValue;
}

function setData(path: string, data: {}, newData: {}) {
  const splitPath = pathSplitter(path);
  for (const walk of splitPath.newPath) {
    data = data[walk];
  }
  data[splitPath.lastKey] = newData;
}

function pathSplitter(path: string): SplitPath {
  const newPath: string[] = path.split(PATH_SEPARATOR);
  const lastItem = newPath.pop();
  const splitPath: SplitPath = {
    newPath: newPath,
    lastKey: lastItem,
  };
  return splitPath;
}

function getAllIndexes(arr: string[], val: string) {
  const indexes = [];
  for (const item of arr) {
    if (item.indexOf(val) !== -1) {
      indexes.push(item);
    }
  }
  return indexes;
}

function setValidation(layout: any): ValidatorFn[] {
  if (layout !== undefined && layout) {
    return getValidators(layout);
  }
  return [];
}

function diff(obj1: object = {}, obj2: object = {}, path?): Array<string> {
  return reduce(
    obj1,
    function (result, value, key) {
      const p = path ? `${path}.${key}` : key;
      if (isObject(value)) {
        const d = diff(value, obj2[key], p);
        return d.length ? result.concat(d) : result;
      }
      return isEqual(value, obj2[key]) ? result : result.concat(p);
    },
    []
  );
}

const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
const translate = {
  nbsp: ' ',
  amp: '&',
  quot: '"',
  lt: '<',
  gt: '>',
};

const decode = (str: string) => {
  return str
    .replace(translate_re, function (match, entity) {
      return translate[entity];
    })
    .replace(/&#(\d+);/g, (match, dec) => {
      return String.fromCodePoint(dec);
    });
};
